export default __webpack_public_path__ + "static/media/PAYW-Pro-Bold.a1771f12.otf";